export default "__VITE_ASSET__B9g3rRst__"